/**
 * IT-панель — учётные записи сотрудников в корпоративных сервисах.
 *
 * До #5737 этих запросов не было вовсе: экран `/itadmin` печатал список,
 * зашитый в `ITAdminPage.jsx`, — ФИО сотрудников рядом с их личными
 * Telegram-логинами. Бандл отдаётся браузеру до всякой проверки роли,
 * поэтому список читал кто угодно.
 *
 * Ответ намеренно НЕ кладётся в `localStorage` (в отличие от большинства
 * разделов, которые ходят через `fetchWithFallback`): это личные контакты
 * людей, и сохранённая копия пережила бы и отзыв роли, и выход из системы.
 * Отказ сервера здесь честнее пустого экрана с прошлогодней копией.
 *
 * Одного `apiFetch` для этого мало: service worker кладёт ЛЮБОЙ ответ `/api/`
 * в `onboardix-api-cache` на сутки, и выход из системы это хранилище не
 * чистит. Поэтому маршрут выведен в `NetworkOnly` — `erp/vite.config.js`,
 * рядом с timesheet/payroll/employees. Обе половины нужны вместе: без правила
 * в конфиге обещание выше неверно, копия просто лежит не там, где её искали.
 */

import { apiFetch } from './core'

export const itAdmin = {
    /** Учётные записи, доступ к папкам и сводка по ним. */
    accounts: () => apiFetch('/it-provisioning/accounts'),
}
